import * as React from 'react';
import styled from 'styled-components';
import StyledButton, { ButtonProps } from './styledButton';
import COLOR from 'constants/color';

interface ButtonWithIconProps {
  icon: React.ReactNode;
  mainText: string | React.ReactNode;
  description: string | React.ReactNode;
}

type Props = ButtonProps & ButtonWithIconProps;

const ButtonWithIcon = (props: Props): JSX.Element => {
  return (
    <Button
      {...props}
    >
      {props.icon}
      <TextContainer disabled={props.disabled}>
        <span>{props.mainText}</span>
        <Description>{props.description}</Description>
      </TextContainer>
    </Button>
  );
};

const Button = styled(StyledButton)`
  display: flex;
  flex-direction: row;
  height: fit-content;
  padding: 1rem;
  align-items: center;
  width: 100%;
  ${(props): string => (props.disabled ? 'opacity: 0.5;' : '')};
`;

const TextContainer = styled.div<{ disabled?: boolean }>`
  color: ${(props): string => props.disabled ? COLOR.midDarkGrey : COLOR.black};
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`;

const Description = styled.span`
  color: ${COLOR.midDarkGrey};
  font-size: 0.75rem;
`;

export default ButtonWithIcon;